import AtomicCDN from "../../../../src/courses/partials/atomic/cdn.mdx";
import * as React from 'react';
export default {
  AtomicCDN,
  React
};